import NextLink from 'next/link';

const MaybeNextLink = ({ href, prefetch, ...rest }: React.ComponentPropsWithRef<typeof NextLink>) => {
    if (typeof href === 'string' && !href.startsWith('/')) {
        return <a href={href} {...rest} />;
    }
    return <NextLink prefetch={prefetch} href={href} {...rest} />;
};

const Link = MaybeNextLink;

export { Link };
